import { BookOpen, Users, Shield, Award } from 'lucide-react';
import SeoHead from '../components/SeoHead';

export default function GhostwriterAbout() {
  return (
    <>
      <SeoHead
        title="About AI Ghostwriter Pro — Our Mission to Help Authors Publish Books"
        description="Learn about AI Ghostwriter Pro, the premium AI-powered ghostwriting service helping aspiring authors turn their ideas into professionally published books. Our team combines cutting-edge AI with editorial expertise."
        keywords="about AI ghostwriter pro, ghostwriting company, who are AI ghostwriter pro, ghostwriting team, professional ghostwriting company, book ghostwriting agency"
        path="/about"
      />

      <section className="pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-7">
              <p className="font-sans uppercase tracking-[0.2em] text-xs font-bold text-primary mb-4">About Us</p>
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight mb-8">
                Turning Ideas Into<br /><span className="text-primary">Published Books</span>
              </h1>
              <div className="space-y-6 text-muted-foreground leading-relaxed">
                <p>AI Ghostwriter Pro was born from a simple belief: everyone has a story worth telling, and no one should be held back by the mechanics of writing.</p>
                <p>We combine cutting-edge AI technology with experienced human editors to deliver publication-ready manuscripts that capture your unique voice and vision. Our service bridges the gap between your ideas and the bookshelf.</p>
                <p>Whether you are a first-time author with a dream or a seasoned professional looking to scale your output, we provide the tools and expertise to bring your book to life.</p>
              </div>
            </div>
            <div className="lg:col-span-5">
              <img
                src="https://images.unsplash.com/photo-1559143255-903e3c79ad5d?q=80&w=1200&auto=format&fit=crop"
                alt="Writing workspace"
                className="w-full h-[400px] object-cover rounded-sm opacity-70"
              />
            </div>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-24">
            {[
              { icon: BookOpen, title: 'Quality First', desc: 'Every manuscript undergoes multiple rounds of AI generation and human editing.' },
              { icon: Users, title: 'Author-Centric', desc: 'Your vision drives the project. We adapt to your voice, style, and goals.' },
              { icon: Shield, title: 'Full Ownership', desc: '100% copyright yours. Your name, your book, your royalties.' },
              { icon: Award, title: 'Publication Ready', desc: 'Formatted for every major platform. Ready to publish on day one.' },
            ].map((v, i) => (
              <div key={i} className="bg-white/5 border border-white/10 rounded-sm p-8" data-testid={`about-value-${i}`}>
                <v.icon className="w-8 h-8 text-primary mb-4" strokeWidth={1.5} />
                <h3 className="font-serif text-xl mb-3 text-foreground">{v.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>

          {/* Powered by */}
          <div className="mt-24 text-center">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Powered By</p>
            <a href="https://web-techservices.com" target="_blank" rel="noreferrer" className="font-serif text-2xl text-primary hover:text-foreground transition-colors">
              Web-TechServices.com AI
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
